import { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import dayjs from 'dayjs'
import { colors } from '@lmc/common/constants'
import { ChartLogList } from '../../../../components/generic'
import withToolbar from '../withToolbar'
import Highcharts from './Highcharts'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import chartTitles from '../chartTitles'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

class FluidsChart extends Component {
  // eslint-disable-next-line class-methods-use-this
  getSeriesData(data, type) {
    return _.chain(data)
      .filter((d) => !d.deleted)
      .groupBy((log) =>
        dayjs(log.timeLogged).utc().startOf('day').add(1, 'h').format()
      )
      .map((value, date) => {
        const total = _.chain(value)
          .map(`measurements.${type}.value`)
          .filter(_.isNumber) // triggers error for non numeric values
          .sum()
          .value()

        return [Date.parse(dayjs(date).toString()), total] // { x: date, y: total }
      })
      .value()
  }

  render() {
    const { logs, to, from } = this.props
    const chartColors = [colors.purple, colors.green]
    const fluidsInLogs = _.filter(logs, (log) =>
      _.get(log, 'measurements.fluids_in.value')
    )
    const fluidsOutLogs = _.filter(logs, (log) =>
      _.get(log, 'measurements.fluids_out.value')
    )

    const series = []
    if (fluidsInLogs && fluidsInLogs.length) {
      series.push({
        name: 'Fluids in',
        stack: 'fluids_in',
        color: fluidsInLogs[0].categoryColor || chartColors[0],
        data: this.getSeriesData(fluidsInLogs, 'fluids_in'),
      })
    }

    if (fluidsOutLogs && fluidsOutLogs.length) {
      series.push({
        name: 'Fluids out',
        stack: 'fluids_out',
        color: fluidsOutLogs[0].categoryColor || chartColors[1],
        data: this.getSeriesData(fluidsOutLogs, 'fluids_out'),
      })
    }

    const config = {
      title: chartTitles.fluids,
      yAxisLabel: 'Fluids In / Out (ml)',
      legendEnabled: true,
      to,
      from,
      chartType: 'column',
      series,
      plotOptions: {
        turboThreshold: 10000,
      },
    }

    return logs && logs.length ? (
      <div>
        {series.length ? <Highcharts config={config} /> : null}
        <ChartLogList logs={logs} />
      </div>
    ) : (
      <EmptyState
        title="Shoot... No data to show you"
        description="No logs to display"
        icon={<NoDataIcon />}
      />
    )
  }
}

FluidsChart.propTypes = {
  from: PropTypes.object,
  logs: PropTypes.array,
  to: PropTypes.object,
}

export default withToolbar(FluidsChart, {
  pdfExport: {
    title: 'Fluids Chart',
  },
  timeWindow: 7 * 4,
})
